import { atom } from 'recoil';
import { STORE_KEYS } from '../keys';


export const fulfilmentFilter = atom<string>({
  key: STORE_KEYS.FILFULMENT_FILTER,
  default: 'Confirmed'
});
